import { render, staticRenderFns } from "./QueclinkTrackerStatisticsTable.vue?vue&type=template&id=96e80288"
import script from "./QueclinkTrackerStatisticsTable.vue?vue&type=script&lang=js"
export * from "./QueclinkTrackerStatisticsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports